module.exports = __webpack_public_path__ + "static/media/mitsubishi-off-app-provider-icon.c8ab9eed.svg";